<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('DistributionOrderList.distributionOrderList')">
                <template v-slot:left>
                    <i class="fa fa-boxes fa-3x text-distribution"/>
                </template>
            </PageTitle>
<!--            <DistributionOrderListFilters/>-->
            <transition mode="out-in" name="fade">
                <APILoading v-if="orders === undefined" key="loading" :color="$data.$colors.distribution" :text="$t('DistributionOrderList.loadingOrders')"/>
                <div class="row" key="orders" v-else>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <v-client-table :data="orders" :columns="table.columns" :options="table.options">
                                    <span slot-scope="props" slot="reference">
                                        <v-popover placement="right">
                                            <button v-tooltip="$t('DistributionOrderList.seeAllReferences')" class="btn btn-info btn-xs mr-1 tooltip-target">
                                                <i class="fa fa-th-list"/>
                                            </button>
                                            <span v-html="props.row.reference" class="font-bold"/>
                                            <template slot="popover">
                                                <div>
                                                    <div class="font-bold" v-html="$t('DistributionOrderList.reference')"/>
                                                    <div v-html="props.row.reference"/>
                                                </div>
                                                <div v-if="props.row.billing.reference.proForma">
                                                    <hr/>
                                                    <div class="font-bold" v-html="$t('DistributionOrderList.proForma')"/>
                                                    <div v-html="props.row.billing.reference.proForma"/>
                                                </div>
                                                <div v-if="props.row.billing.reference.bill">
                                                    <hr/>
                                                    <div class="font-bold" v-html="$t('DistributionOrderList.bill')"/>
                                                    <div v-html="props.row.billing.reference.bill"/>
                                                </div>
                                                <div v-if="props.row.billing.reference.credit">
                                                    <hr/>
                                                    <div class="font-bold" v-html="$t('DistributionOrderList.credit')"/>
                                                    <div v-html="props.row.billing.reference.credit"/>
                                                </div>
                                            </template>
                                        </v-popover>
                                    </span>
                                    <a class="font-bold" href="#" slot-scope="props" slot="user" v-html="props.row.user.getFullName(hermesShop.type)"/>
                                    <a href="#" slot-scope="props" slot="productAmount" v-html="props.row.productAmountLabel"
                                       v-tooltip="$t('DistributionOrderList.seeContent')"/>
                                    <span slot-scope="props" slot="totalWT" v-html="formatPrice(props.row.totalWT, props.row.currency, currencies)"/>
                                    <DistributionOrderPaymentStatus slot-scope="props" slot="paymentStatus" :order="props.row"/>
                                    <DistributionOrderProductionStatus slot-scope="props" slot="productionStatus" :order="props.row"/>
                                    <span slot-scope="props" slot="createdAt" v-html="properDateTime(props.row.createdAt)"/>
                                    <div slot-scope="props" slot="actions">
                                        <div class="w-25">
                                            <DownloadDistributionOrderBilling text="<i class='fa fa-download'/>"
                                                                              classes="btn btn-info btn-xs ml-1"
                                                                              :order="props.row"/>
                                        </div>
                                    </div>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import PageTitle from "../../../shared/misc/PageTitle";
import APILoading from "../../../shared/API/APILoading";
import { mapActions, mapGetters } from "vuex";
import DistributionOrder from "../../../../classes/Distribution/DistributionOrder";
import { permissiveFilter } from "../../../../helpers/VueTable";
import { formatPrice } from "../../../../helpers/Billing";
import { properDateTime } from "../../../../helpers/Date";
import DistributionOrderPaymentStatus
    from "../../../shared/Distribution/DistributionOrder/DistributionOrderPaymentStatus";
import DistributionOrderProductionStatus
    from "../../../shared/Distribution/DistributionOrder/DistributionOrderProductionStatus";
import DownloadDistributionOrderBilling from "../../../shared/Distribution/DownloadDistributionOrderBilling";

export default {
    name: "DistributionOrderList",
    components: {
        DownloadDistributionOrderBilling,
        DistributionOrderProductionStatus, DistributionOrderPaymentStatus, APILoading, PageTitle },
    // eslint-disable-next-line max-lines-per-function
    data() {
        return {
            orders: undefined,
            table: {
                columns: ["reference", "user", "productAmount", "totalWT", "paymentStatus", "productionStatus", "createdAt", "actions"],
                options: {
                    sortable: ["reference", "user", "productAmount", "totalWT", "paymentStatus", "productionStatus", "createdAt"],
                    perPage: 10,
                    headings: {
                        reference: this.$t("DistributionOrderList.reference"),
                        user: this.$t("DistributionOrderList.client"),
                        productAmount: this.$t("DistributionOrderList.content"),
                        totalWT: this.$t("DistributionOrderList.totalWT"),
                        productionStatus: this.$t("DistributionOrderList.production"),
                        paymentStatus: this.$t("DistributionOrderList.payment"),
                        createdAt: this.$t("DistributionOrderList.ordered"),
                        actions: this.$t("DistributionOrderList.actions"),
                    },
                    orderBy: {
                        column: "createdAt",
                        ascending: false,
                    },
                    filterAlgorithm: {
                        reference: (row, query) => permissiveFilter(row.reference, query) ||
                            permissiveFilter(row.billing.reference.proForma, query) ||
                                permissiveFilter(row.billing.reference.bill, query) ||
                                permissiveFilter(row.billing.reference.credit, query),
                        user: (row, query) => permissiveFilter(row.user.getFullName(this.hermesShop.type), query),
                        totalWT: (row, query) => permissiveFilter(formatPrice(row.totalWT, row.currency, this.currencies), query),
                        paymentStatus: (row, query) => permissiveFilter(row.paymentStatusLabel, query),
                        productionStatus: (row, query) => permissiveFilter(row.productionStatusLabel, query),
                        createdAt: (row, query) => permissiveFilter(properDateTime(row.createdAt), query),
                    },
                    cellClasses: {
                        productAmount: [{
                            class: "text-center",
                            condition: () => true,
                        }],
                        totalWT: [{
                            class: "text-center",
                            condition: () => true,
                        }],
                        productionStatus: [{
                            class: "text-center",
                            condition: () => true,
                        }],
                        paymentStatus: [{
                            class: "text-center",
                            condition: () => true,
                        }],
                        actions: [{
                            class: "text-center",
                            condition: () => true,
                        }],
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters("currencies", {
            currencies: "currencies",
        }),
        ...mapGetters("hermesAPIConfig", {
            hermesShop: "shop",
        }),
    },
    async created() {
        if (!await this.checkUserAuthentication()) {
            return;
        }
        await this.getOrders();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
        async getOrders() {
            try {
                const { data } = await this.$hermesAPI.getOrders();
                this.orders = data.map(order => new DistributionOrder(order));
            } catch (e) {
                this.$displayError(e);
            }
        },
        downloadBillingDocument(order, type = null) {
            if (!type) {
                type = order.defaultBillingDocument;
            }
        },
        formatPrice, properDateTime,
    },
};
</script>

<style scoped>

</style>